
import { defineComponent, inject } from 'vue';
import { SQ_PROVIDE_KEY } from '../helpers/settings';
import { getFactors, resetFactors } from '../requests/Users';

const factorReadableMapping = {
  'token:software:totp,GOOGLE': 'Google Auth',
  'token:software:totp,OKTA': 'Okta Verify',
  'webauthn,FIDO': 'Webauthn',
  'sms,OKTA': 'SMS (text)'
};

export default defineComponent({
  props: {
    userId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      mfaInfo: null,
      isProcessing: false,
      hasError: false
    };
  },

  computed: {
    getFactorSummary(): string[] {
      const activeFactors = this.mfaInfo.factors.filter((factor) => {
        return factor.status === 'ACTIVE';
      });
      const inactiveFactors = this.mfaInfo.factors.filter((factor) => {
        return factor.status !== 'ACTIVE';
      });
      const allFactors = [...activeFactors, ...inactiveFactors];
      if (allFactors.length) {
        return allFactors.filter((factor) => {
          return factor.factorType !== 'email';
        }).map((factor) => {
          const readableName = factorReadableMapping[`${factor.factorType},${factor.provider}`];
          return `${readableName || 'Unknown'} (${factor.status})`;
        });
      } else {
        return ['(None found)'];
      }
    }
  },

  methods: {
    resetFactors() {
      this.hasError = false;
      this.isProcessing = true;
      resetFactors(this.sqBaseUrl, this.userId).subscribe({
        next: () => {
          this.isProcessing = false;
          this.loadFactorInfo();
        },
        error: () => {
          this.isProcessing = false;
          this.hasError = true;
        }
      });
    },

    loadFactorInfo() {
      getFactors(this.sqBaseUrl, this.userId).subscribe((result) => {
        this.mfaInfo = result;
      });
    }
  },

  setup() {
    const sqBaseUrl: string = inject(SQ_PROVIDE_KEY);
    return { sqBaseUrl };
  },

  beforeMount() {
    this.loadFactorInfo();
  }

});
